































































import { Component, Vue, Prop } from 'vue-property-decorator'

import { format } from 'date-fns'
import { TextFieldRules, Gender, GenderText } from '@/utils/enums'
import MessageAlert from '@/components/MessageAlert.vue'

@Component({
  name: 'OptionalSettingsDialog',
  components: {
    MessageAlert
  }
})
class OptionalSettingsDialog extends Vue {
  @Prop() readonly hidePromoCode?: boolean
  private isFormValid = false
  private birthDateMenu = false
  private rules = TextFieldRules
  private form = {
    promotionCode: '',
    gender: '',
    birthDate: ''
  }

  private get gender() {
    return Object.entries(Gender).map(entry => [GenderText[entry[0]], entry[1]])
  }

  private get formattedBirthDate(): string {
    if (!this.form.birthDate) return ''
    return format(new Date(this.form.birthDate), 'dd.MM.yyyy')
  }
}

export default OptionalSettingsDialog
